import React, { useEffect, useState } from 'react';
import ErrorDialog from './ErrorDialog';
import { API_ERROR_EVENT } from '../utils/reportApiError';

/**
 * The panel's only error dialog. Mounted once in `App.js`, it listens for the
 * events `reportApiError` / `reportError` send and shows the last one.
 *
 * A second error arriving while one is on screen replaces it: two dialogs
 * stacked on each other say less than the newer one alone, and the older
 * message describes an operation the user has already left behind.
 */
export default function AppErrorDialog() {
  const [error, setError] = useState(null);

  useEffect(() => {
    const showError = (event) => setError(event.detail);
    window.addEventListener(API_ERROR_EVENT, showError);
    return () => window.removeEventListener(API_ERROR_EVENT, showError);
  }, []);

  if (!error) {
    return null;
  }

  return (
    <ErrorDialog
      open
      title={error.title}
      message={error.message}
      onCloseButtonClicked={() => setError(null)}
    />
  );
}
